import Progress from 'antd/lib/progress';
import Tooltip from 'antd/lib/tooltip';
import Text from 'antd/lib/typography/Text';
import * as React from 'react';
import { antGrey, runwayColors } from '../styles/globalStyles';

interface ContributorChartProps {
    title: string | JSX.Element;
    members: { name: string; itemOfWorkCount: number }[];
}

const ContributorChart: React.FC<ContributorChartProps> = (props: ContributorChartProps) => {
    const { title, members } = props;

    const sortedMembers = [...members].sort((prev, current) => current.itemOfWorkCount - prev.itemOfWorkCount);
    const largestItemOfWorkCount = sortedMembers[0]?.itemOfWorkCount ?? 0;
    const topFourMembers = sortedMembers.slice(0, 4);

    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Text style={{ color: antGrey.grey7 }}>{title}</Text>
                <Text style={{ color: antGrey.grey8, fontSize: '24px', fontWeight: 600 }}>{members.length}</Text>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {topFourMembers.map((member, idx) => {
                    return (
                        <div key={member.name + idx} style={{ display: 'flex', alignItems: 'center' }}>
                            <Progress
                                className="bordered"
                                percent={
                                    largestItemOfWorkCount > 0 ?
                                        (member.itemOfWorkCount / largestItemOfWorkCount) * 100
                                    :   0
                                }
                                strokeColor={runwayColors.statusGreen}
                                style={{ marginRight: 12, width: '70%', flexShrink: 0 }}
                                showInfo={false}
                            />
                            <Tooltip
                                title={
                                    member.name +
                                    `: ` +
                                    member.itemOfWorkCount +
                                    ` item${member.itemOfWorkCount === 1 ? '' : 's'} of work contributed`
                                }
                                placement="right"
                            >
                                <Text type="secondary" ellipsis>
                                    {member.name}
                                </Text>
                            </Tooltip>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ContributorChart;
